<template>

    <v-dropdown
        :prefix="prefix"
        :items="[
            { key: '', value: 'All Time' },
            { key: 'today', value: 'Today' },
            { key: 'yesterday', value: 'Yesterday' },
            { key: 'last7days', value: 'Last 7 Days' },
            { key: 'last4weeks', value: 'Last 4 Weeks' },
        ]"
        :selected="timeframe"
        @change="$emit('change', $event)">
    </v-dropdown>

</template>

<script>

export default {

    props: {
        prefix: {
            type: String,
            default: 'Timeframe',
        },
        timeframe: {
            type: String,
            default: '',
        },
    },

}

</script>
